document.addEventListener('DOMContentLoaded', () => {
  const target = document.querySelector('.sticky-add-to-cart');
  const sentinel = document.createElement('div');

  sentinel.style.height = '1px';
  target.parentNode.insertBefore(sentinel, target);

  let isPastSentinel = false;

  const observer = new IntersectionObserver(
    ([entry]) => {
      isPastSentinel = !entry.isIntersecting;
      updateStickyState();
    },
    { threshold: 0 },
  );

  observer.observe(sentinel);

  function updateStickyState() {
    if (isPastSentinel && window.scrollY > 200) {
      target.classList.add('fixed-bottom');
    } else {
      target.classList.remove('fixed-bottom');
    }
  }

  window.addEventListener('scroll', updateStickyState);
});
